import localeContext from './LocaleContext';
export function $l(component, key, defaults) {
    return localeContext.get(component, key, defaults);
}
export default localeContext;
